import React from "react";
import { Accordion } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Loading } from "../../components";
import { ApiHelper, EnvironmentHelper, MessageHelper, MessageInterface, TemplateInterface, ToastHelper } from "../../helpers";

interface Props {
  shape: string
}

export const NewMessageType: React.FC<Props> = props => {

  const [templates, setTemplates] = React.useState<TemplateInterface[]>(null);
  const [designerMessages, setDesignerMessages] = React.useState<MessageInterface[]>(null);
  const [yourDesignerMessages, setYourDesignerMessages] = React.useState<MessageInterface[]>(null);

  const init = () => {
    ApiHelper.get<TemplateInterface[]>("/templates/available")
      .then((data) => {
        const result: TemplateInterface[] = [];
        (data || []).forEach(d => {
          if (d.templateType === "message" && d.shapes?.indexOf(props.shape) > -1) result.push(d);
        });
        setTemplates(result)
      })
      .catch(err => {
        console.error("Failed to load templates:", err);
        ToastHelper.error("Failed to load message templates");
      });

    ApiHelper.get<MessageInterface[]>("/messages/public")
      .then((data) => {
        const result: MessageInterface[] = [];
        (data || []).forEach(d => { if (d.shape === props.shape) result.push(d); });
        setDesignerMessages(result)
      })
      .catch(err => console.error("Failed to load designer messages:", err));

    ApiHelper.get<MessageInterface[]>("/messages/yourDesigner")
      .then((data) => {
        const result: MessageInterface[] = [];
        (data || []).forEach(d => { if (d.shape === props.shape) result.push(d); });
        setYourDesignerMessages(result)
      })
      .catch(err => console.error("Failed to load your designer messages:", err));
  }

  React.useEffect(init, [props.shape])

  const getAccordion = () => {
    const popularSection = getSection("popular", "Popular Message Templates", getPopular())
    const templateSection = (templates?.length > 4) ? getSection("templates", "All Message Templates", getTemplates()) : <></>;
    const designerSection = (designerMessages?.length > 0) ? getSection("designer", "Designer Templates", getDesigner()) : <></>;
    const yourDesignerSection = (yourDesignerMessages?.length > 0) ? getSection("yourDesigner", "Your Designer Messages", getYourDesigner()) : <></>;

    return (<Accordion id={"newMessage"} defaultActiveKey={"popular"} >
      {popularSection}
      {templateSection}
      {designerSection}
      {yourDesignerSection}
    </Accordion>)
  }

  const getSection = (eventKey: string, title: string, contents: React.ReactElement) => {
    return (
      <Accordion.Item eventKey={eventKey}>
        <Accordion.Header>{title}</Accordion.Header>
        <Accordion.Body>{contents}</Accordion.Body>
      </Accordion.Item>
    )
  }

  const getPopular = () => {
    const result: React.ReactElement[] = [];
    const thumbnailFile = (props.shape === "9:16") ? "thumbnailV.png" : "thumbnail.png";
    let i = 0;
    for (let t of templates) {
      if (i < 5) {
        result.push(<div key={"t" + t.id} className="col-6 col-md-3 col-xl-2">
          <Link to={"/messages/0?templateId=" + t.id + "&shape=" + props.shape}>
            <img src={EnvironmentHelper.ContentRoot + "/templates/" + t.id + "/" + thumbnailFile} alt="thumbnail" />
            <span>{t.name}</span>
          </Link>
        </div>);
      }
      i++;
    }
    return (<div id="templateList" className="row templateList condensed">{result}</div>);
  }

  const getTemplates = () => {
    const result: React.ReactElement[] = [];
    const thumbnailFile = (props.shape === "9:16") ? "thumbnailV.png" : "thumbnail.png";
    templates.forEach(t => {
      result.push(<div className="col-6 col-md-3 col-xl-2">
        <Link to={"/messages/0?templateId=" + t.id + "&shape=" + props.shape}>
          <img src={EnvironmentHelper.ContentRoot + "/templates/" + t.id + "/" + thumbnailFile} alt="thumbnail" />
          <span>{t.name}</span>
        </Link>
      </div>);
    });
    return (<div id="templateList" className="row templateList condensed">{result}</div>);
  }

  const getDesigner = () => {
    const result: React.ReactElement[] = [];
    designerMessages?.forEach(m => {
      const thumbPath = MessageHelper.getThumbnailPath(m);
      result.push(<div className="col-6 col-md-3 col-xl-2">
        <Link to={"/messages/0?templateId=" + m.templateId + "&shape=" + props.shape + "&copyFrom=" + m.id}>
          <img src={thumbPath} alt="thumbnail" />
          <span>{m.name}</span>
        </Link>
      </div>);
    });
    return (<div id="designerList" className="row condensed">{result}</div>);
  }

  const getYourDesigner = () => {
    const result: React.ReactElement[] = [];
    yourDesignerMessages?.forEach(m => {
      const thumbPath = MessageHelper.getThumbnailPath(m);
      result.push(<div className="col-6 col-md-3 col-xl-2">
        <Link to={"/messages/0?templateId=" + m.templateId + "&shape=" + props.shape + "&copyFrom=" + m.id}>
          <img src={thumbPath} alt="thumbnail" />
          <span>{m.name}</span>
        </Link>
      </div>);
    });
    return (<div id="designerList" className="row condensed">{result}</div>);
  }

  if (templates === null) return <Loading />
  else return getAccordion();
};